import React, { Component } from 'react';
import prev from '../../../Images/Icons/carat-l-black.svg';
import next from '../../../Images/Icons/carat-r-black.svg';
import { isEmpty, handleDownloadCSV } from '../../Common/Common';
import Select from '../../Part_Sample/Select';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Calendar from '../../Part_Sample/Calendar';
import Chart_Trend from '../../Part_Sample/Chart_Trend';
import { getTrendChartData } from '../util/util';
import { navigateReport } from '../../Common/navigation';
import down_icon from '../../../Images/Daikin_Images/image/down.png';
import up_icon from '../../../Images/Daikin_Images/image/up.png';

export default class Trend_Data extends Component {
	constructor(props) {
		super(props);
		// Selection of points taken from param (i.e. previous screen). 
		// So set the points to query before switching to this screen

		// The dates used for the current search, may not be the same as display
		// Used to compare if current data already contain data for new search, in which case no need query again
		this.search_start_date = new Date();
		this.search_end_date = new Date();

		let duration = '24'; // by hours
		let interval = '5'; // by minutes

		this.trend_data = {};
		if (this.props.param.trend_data != null) this.trend_data = this.props.param.trend_data;

		let selected_date = new Date();
		let from_hour = 0;
		if (this.props.param.search_start_date != null) {
			selected_date = this.props.param.search_start_date;
			this.search_start_date = this.props.param.search_start_date;
			from_hour = selected_date.getHours();
		}

		if (this.props.param.search_end_date != null) {
			this.search_end_date = this.props.param.search_end_date;
			duration = Math.abs((this.search_end_date - this.props.param.search_start_date) / 1000 / 60 / 60).toString();
		}

		if (this.props.param.interval != null) interval = this.props.param.interval;

		//Alex 20220420 Check data, remove all SP category START
		// if(!isEmpty(this.trend_data)) {
		// 	if(this.trend_data.hasOwnProperty('data')){
		// 		if(!isEmpty(this.trend_data.data)) {
		// 			console.log('Before loop, data not empty');

		// 			for(var pid in this.trend_data.data) {
		// 				console.log('Inside loop, before empty check');
		// 				if(!isEmpty(this.trend_data.data[pid])) {
		// 					console.log('After empty check, before sp check');
		// 					if(this.trend_data.data[pid].hasOwnProperty('sp')) {
		// 						delete this.trend_data.data[pid].sp;
		// 					}

		// 					if(this.trend_data.data[pid].hasOwnProperty('temp')) {
		// 						this.trend_data.data[pid].non = this.trend_data.data[pid].temp;
		// 						delete this.trend_data.data[pid].temp;
		// 					}
		// 				}
		// 			}
		// 		}
		// 	}
		// }
		//Alex 20220420 Check data, remove all SP category END

		this.state = {
			is_show_calendar: false,
			selected_date: selected_date,
			from_hour: from_hour,
			duration: duration,
			interval: interval,
			chart_data: getTrendChartData(this.trend_data, selected_date, duration, interval),
		}

		this.chart = React.createRef();
	}

	handlePrevious = () => {
		if (this.props.param.from == 'Layout') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			window.app.receiver.stored_params.layout_id = this.props.param.layout_id;
			window.app.receiver.next_component = 'Layout';
			window.app.receiver.getGroups();
		} else {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			this.props.content_handler(this.props.param.from, this.props.param);
		}
	}

	handleSelectDevices = () => {
		let param = this.props.param;
		let search_start_date = new Date(this.state.selected_date);
		search_start_date.setHours(this.state.from_hour);
		let search_end_date = new Date(search_start_date);
		search_end_date.setHours(search_start_date.getHours() + parseInt(this.state.duration));

		param.search_start_date = search_start_date;
		param.search_end_date = search_end_date;
		param.interval = this.state.interval;
		param.original_from = this.props.param.from;
		param.from = 'Trend_Data';

		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('Trend_Data_Select_Points', param);
	}

	toggleCalendar = () => {
		this.setState({ is_show_calendar: !this.state.is_show_calendar });
	}

	handleChangeCalDate = (selected_date) => {
		let now = new Date();
		// Check that selected_date + from_hour is smaller than the time now
		let check_date = new Date(selected_date);
		check_date.setHours(this.state.from_hour);

		if (check_date > now) {
			this.setState({
				selected_date: now,
				from_hour: now.getHours(),
				is_show_calendar: false
			}, this.handleQuery);
		} else {
			this.setState({
				selected_date: selected_date,
				is_show_calendar: false
			}, this.handleQuery);
		}
	}

	handleChangeFromHour = (val) => {
		this.setState({ from_hour: val }, this.handleQuery);
	}

	handleChangeDuration = (val) => {
		this.setState({ duration: val }, this.handleQuery);
	}

	handleChangeInterval = (val) => {
		this.setState({
			interval: val,
			chart_data: getTrendChartData(this.trend_data, this.state.selected_date, this.state.duration, val),
		}, this.chart.current.generateChart);
	}

	handlePrev = () => {
		let new_date = new Date(this.state.selected_date);
		new_date.setHours(parseInt(this.state.from_hour) - parseInt(this.state.duration));

		this.setState({
			selected_date: new_date,
			from_hour: new_date.getHours(),
		}, this.handleQuery)
	}

	handleNext = () => {
		let new_date = new Date(this.state.selected_date);
		new_date.setHours(parseInt(this.state.from_hour) + parseInt(this.state.duration));

		let now = new Date();
		if (new_date > now) new_date = now;

		this.setState({
			selected_date: new_date,
			from_hour: new_date.getHours(),
		}, this.handleQuery)
	}

	handleQuery = () => {
		window.app.showLoading();
		let points = this.props.param.points;

		let start_date = this.state.selected_date;
		start_date.setHours(parseInt(this.state.from_hour));
		start_date.setMinutes(0);

		let end_date = new Date(start_date);
		end_date.setHours(start_date.getHours() + parseInt(this.state.duration));

		// Check if data already exists by comparing previous search_start_date and search_end_date
		if (start_date >= this.search_start_date && end_date <= this.search_end_date) {
			window.app.hideLoading();
			this.setState({
				chart_data: getTrendChartData(this.trend_data, this.state.selected_date, this.state.duration, this.state.interval),
			}, this.chart.current.generateChart);

			return;
		} else {
			this.search_start_date = start_date;
			this.search_end_date = end_date;
		}

		let search_details = {
			fy: start_date.getFullYear(),
			fm: start_date.getMonth() + 1,
			fd: start_date.getDate(),
			fh: start_date.getHours(),
			fmin: start_date.getMinutes(),
			ty: end_date.getFullYear(),
			tm: end_date.getMonth() + 1,
			td: end_date.getDate(),
			th: end_date.getHours(),
			tmin: end_date.getMinutes(),
			points: points
		}

		this.props.receiver.getTrend(search_details);
	}

	rcvTrendData = (trend_data) => {
		window.app.hideLoading();
		// Update trend_data for if user change interval
		this.trend_data = trend_data;
		this.setState({
			chart_data: getTrendChartData(this.trend_data, this.state.selected_date, this.state.duration, this.state.interval),
		}, this.chart.current.generateChart);
	}

	// Save as csv
	handleLeftButtonAction = () => {

		let Today = new Date();
		let file_name = "Trend_Data_" + Today.getFullYear()
			+ (Today.getMonth() < 10 ? '0' : '') + (Today.getMonth() + 1)
			+ (Today.getDate() < 10 ? '0' : '') + (Today.getDate())
			+ '.csv';

		let csv = [];
		let chart_data = this.state.chart_data;
		let num_of_columns = chart_data[0].length;
		for (let x = 0; x < num_of_columns; x++) {
			let row = [];
			for (let index in chart_data) {
				let data = chart_data[index];
				if (data[x] == "x") row.push("");
				else row.push(data[x]);
			}
			csv.push(row.join(","));
		}
		handleDownloadCSV(csv.join("\n"), file_name);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		let select_style = {
			height: 30,
			textAlign: 'center',
			verticalAlign: 'top',
			cursor: 'pointer',
			display: 'inline-block',
			marginLeft: 10,
		}

		let content_height = 100;

		let cal_width = this.props.width - 40;
		let cal_height = 200;

		let chart_width = this.props.width - 10;
		let chart_height = this.props.height - 270;

		if (chart_height < 300) chart_height = 300;

		let hours = [];
		let now = new Date();
		let selected_date = new Date(this.state.selected_date);
		selected_date.setHours(0, 0, 0);
		// hours_diff = The no. hours difference between search start date and now.
		let hours_diff = Math.abs((now - selected_date) / 1000 / 60 / 60);
		if (hours_diff < 23) {
			let max_hour = now.getHours();
			for (let i = 0; i <= max_hour; i++) {
				if (i < 10) {
					hours.push(<option value={i}>0{i}:00</option>)
				} else {
					hours.push(<option value={i}>{i}:00</option>)
				}
			}
		} else {
			for (let i = 0; i < 24; i++) {
				if (i < 10) {
					hours.push(<option value={i}>0{i}:00</option>)
				} else {
					hours.push(<option value={i}>{i}:00</option>)
				}
			}
		}

		let durations = [];
		let duration_list = ['6', '12', '24', '48'];
		for (let i in duration_list) {
			durations.push(<option value={duration_list[i]}>{duration_list[i]} {this.props.receiver.getString('hours')}</option>);
		}

		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		// Intervals are by minutes. Shows how detail the chart can be.
		// Eg. If 5 min is selected, shows data points every 1 hour
		let intervals = [];
		intervals.push(<option value="60">{this.props.receiver.getString("select_interval_1hr")}</option>);
		intervals.push(<option value="30">{this.props.receiver.getString("select_interval_30min")}</option>);
		intervals.push(<option value="15">{this.props.receiver.getString("select_interval_15min")}</option>);
		intervals.push(<option value="5">{this.props.receiver.getString("select_interval_5min")}</option>);

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('trend_graph')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'edit'}
						handleRightButton={this.handleSelectDevices}
					/>

					<div id="content" className='noScrollBar' style={{ overflow: 'auto', height: this.props.height - 120 }}>
						<div>
							<div id="header" style={{ display: 'flex', width: '90%', margin: '0 auto', }}>
								{/* Date & Time label */}
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40%' }}>
									<span className='title' style={{ fontSize: 16 }}>{this.props.receiver.getString('sel_date') + ': '}</span>
								</div>
								{/* Date */}
								<div onClick={this.toggleCalendar} style={{ cursor: 'pointer', display: 'flex', width: '30%', background: 'lightgray', alignItems: 'center', justifyContent: 'center', padding: 10, borderRadius: 10 }}>
									<span className='title' style={{ fontSize: 16, textDecoration: 'underline' }}>{this.state.selected_date.toLocaleDateString()}</span>
								</div>
								{/* Time */}
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30%', marginLeft: 20, background: 'lightgray', padding: 5, borderRadius: 10 }}>
									{/* Time selection */}
									<Select
										style={{}}
										select_style={{ fontWeight: 700, backgroundColor: 'lightgray', opacity: 1, borderRadius: 0, padding: 0, height: 'auto', color: '#757575' }}
										options={hours}
										value={this.state.from_hour}
										onSelect={this.handleChangeFromHour}
									/>
									<div className='slideInDown' style={{}}>
										<Calendar
											onSelect={this.handleChangeCalDate}
											style={{ visibility: this.state.is_show_calendar ? 'visible' : 'hidden', marginTop: 30 }}
											width={cal_width}
											height={cal_height}
											left={1 - (this.props.width - 60)}
											max_date={new Date()}
											selected_date={this.state.selected_date}
										/>
									</div>
									{/* Arrow indicator icon */}
									<div style={{ display: 'grid', verticalAlign: 'top', marginleft: 5, alignItems: 'center', background: 'lightgray' }}>
										<img src={up_icon} style={{ display: 'block', width: 10 }} />
										<img src={down_icon} style={{ display: 'block', width: 10 }} />
									</div>
								</div>
							</div>

							<div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', height: 60, width: 35, cursor: 'pointer' }} onClick={this.handlePrev}>
									<img src={prev} style={{ marginTop: 22, marginLeft: 10, marginRight: 10 }} />
								</div>

								<div style={{ display: 'inline-block', visibility: this.state.is_show_calendar ? 'hidden' : 'visible' }}>
									<div style={{ display: 'inline-block', width: (this.props.width - 70) / 2 }}>
										<div style={{ verticalAlign: 'top', paddingTop: 10 }}>
											<span>{this.props.receiver.getString('duration') + ':'}</span>
										</div>
										<Select
											select_style={{ ...select_style, width: (this.props.width - 70) / 2 - 20 }}
											options={durations}
											value={this.state.duration}
											onSelect={this.handleChangeDuration}
										/>
									</div>
									<div style={{ display: 'inline-block', width: (this.props.width - 70) / 2 }}>
										<div style={{ verticalAlign: 'top', paddingTop: 10 }}>
											<span>{this.props.receiver.getString('intervals') + ':'}</span>
										</div>
										<Select
											select_style={{ ...select_style, width: (this.props.width - 70) / 2 - 20 }}
											options={intervals}
											value={this.state.interval}
											onSelect={this.handleChangeInterval}
										/>
									</div>
								</div>
								<div style={{ display: 'inline-block', verticalAlign: 'top', height: 60, width: 35, cursor: 'pointer' }} onClick={this.handleNext}>
									<img src={next} style={{ marginTop: 22, marginLeft: 10, marginRight: 10 }} />
								</div>
							</div>
						</div>
						<div style={{ height: this.props.height - 245, overflow: is_landscape ? 'visible' : 'auto', marginTop: 20 }}>
							<Chart_Trend
								style={{ zIndex: this.state.is_show_calendar ? -1 : 1 }}
								ref={this.chart}
								chart_data={this.state.chart_data}
								chart_width={chart_width}
								chart_height={chart_height}
								receiver={this.props.receiver}
								duration={this.state.duration}
							/>
							<div>
								<span style={{ fontSize: 10, display: 'block', marginLeft: 20, marginRight: 20 }}>{this.props.receiver.getString('trend_instr')}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}